import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NavbarHieghtService {

  public height = new ReplaySubject(1);
  currentHeight = this.height.asObservable();

  constructor() { }

  changeHeight(newHeight: number) {
    this.height.next(newHeight);
  }
}
